import notificationSettings from '@/locales/es/setting/notificationSettings.locales';
import occupations from '@/locales/es/setting/occupations.locales';
import overtime from '@/locales/es/setting/overtime.locales';
import procedures from '@/locales/es/setting/procedures.locales';
import products from '@/locales/es/setting/products.locales';
import structures from '@/locales/es/setting/structures.locales';

export default {
    ...notificationSettings,
    ...occupations,
    ...structures,
    ...overtime,
    ...products,
    ...procedures,
};
